import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { MobileProvider } from './contexts/MobileContext';
import Routes from './routes/Routes';
import ScrollToTop from './routes/ScrollToTop';

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <MobileProvider>
          <SidebarProvider>
            <Routes />
          </SidebarProvider>
        </MobileProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
